// ---------------------------------------
// ArticleEvents.js
//   Used to catch article detail events and proceed
// ---------------------------------------

import { pause, play, register, toggleFullscreen, toggleMute } from '../services/players';
import Utils from 'nova-tn-frontend/source/scripts/modules/Utils';

const ArticleEvents = {
  rtePlayers: null,
  firstVideoAutoplayOnScroll: {
    played: false,
    id: null,
    checkIfPlayingTimeout: null,
    isReady: false,
    manuallyPaused: false
  },

  Init: function () {
    ArticleEvents.Methods.ListenToPlayers();

    ArticleEvents.rtePlayers = $('.c-rte .c-player:not(.-sticky)');

    this.AutoPlayArticlesVideoOnScroll();

    if (!ArticleEvents.rtePlayers.length) {
      return;
    }
    const videosData = ArticleEvents.Methods.GetVideosData(
      ArticleEvents.rtePlayers
    );

    ArticleEvents.Methods.WatchForPlayersIntersection(
      videosData,
      ArticleEvents.Callbacks.MakeIntersectionCallback
    );
  },

  /**
   * Handle autoplay of the first video in the article on scroll into view
   */
  AutoPlayArticlesVideoOnScroll: function () {
    const firstVideo = $('.c-rte .c-player').first();
    const { firstVideoAutoplayOnScroll } = ArticleEvents;

    // If the miniplayer or first hero video is present (hero video has always autoplay), or there is no video in the article, do not continue
    if (
      (!Utils.isTouchDevice() && $('.miniplayer-wrap').length) || // Only check miniplayer on desktop
      $('.c-rte .hero-media .c-player').length ||
      !firstVideo.length
    ) {
      return;
    }

    let isVideoPlaying = false;

    firstVideoAutoplayOnScroll.id = firstVideo
      .find('[data-video-id]')
      .attr('data-video-id');

    register((data = {}) => {
      // Check if video is actually playing
      if (data.eventName == 'recurring' && data.id == firstVideoAutoplayOnScroll.id && data.currentTime > 1) {
        isVideoPlaying = true;
      }

      // Clear timeout if video is playing or not playing
      if (
        data.eventName == 'recurring' &&
        data.id == firstVideoAutoplayOnScroll.id &&
        firstVideoAutoplayOnScroll.checkIfPlayingTimeout && !isVideoPlaying
      ) {
        clearTimeout(firstVideoAutoplayOnScroll.checkIfPlayingTimeout);
        firstVideoAutoplayOnScroll.checkIfPlayingTimeout = null;
      }

      // Mark video as ready and check for scroll position if it's the first video
      if (data.eventName == 'init' && data.id == firstVideoAutoplayOnScroll.id) {
        firstVideoAutoplayOnScroll.isReady = true;
        
        // Check if video is already in view when it becomes ready
        const videoOffset = firstVideo.offset().top;
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        
        if (
          scrollTop + windowHeight >= videoOffset &&
          !firstVideoAutoplayOnScroll.played &&
          !firstVideoAutoplayOnScroll.manuallyPaused
        ) {
          play(firstVideoAutoplayOnScroll.id);
          firstVideoAutoplayOnScroll.played = true;
          
          // This is a workaround for the case when the video is not playing after the first play event (browsers policy)
          firstVideoAutoplayOnScroll.checkIfPlayingTimeout = setTimeout(() => {
            toggleMute(firstVideoAutoplayOnScroll.id, true);
            play(firstVideoAutoplayOnScroll.id);
            clearTimeout(firstVideoAutoplayOnScroll.checkIfPlayingTimeout);
            firstVideoAutoplayOnScroll.checkIfPlayingTimeout = null;
          }, 3000);
        }
      }
      
      // Track if video was manually paused
      if (data.eventName == 'pause' && data.id == firstVideoAutoplayOnScroll.id) {
        firstVideoAutoplayOnScroll.manuallyPaused = true;
      }
    });

    // Only set up scroll handling once the video is ready
    $(window).on('scroll', function () {
      if (!firstVideoAutoplayOnScroll.isReady) return;
      
      const videoOffset = firstVideo.offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (
        scrollTop + windowHeight >= videoOffset &&
        !firstVideoAutoplayOnScroll.played &&
        !firstVideoAutoplayOnScroll.manuallyPaused
      ) {
        play(firstVideoAutoplayOnScroll.id);
        firstVideoAutoplayOnScroll.played = true;

        // This is a workaround for the case when the video is not playing after the first play event (browsers policy)
        firstVideoAutoplayOnScroll.checkIfPlayingTimeout = setTimeout(() => {
          toggleMute(firstVideoAutoplayOnScroll.id, true);
          play(firstVideoAutoplayOnScroll.id);
          clearTimeout(firstVideoAutoplayOnScroll.checkIfPlayingTimeout);
          firstVideoAutoplayOnScroll.checkIfPlayingTimeout = null;
        }, 3000);
      }
    });
  },

  State: {
    playerPlayState: {},
    setPlayerIdAsPlaying: (playerId) => {
      ArticleEvents.State.playerPlayState[playerId] = 'playing';
      return ArticleEvents.State.playerPlayState[playerId];
    },
    setPlayerIdAsInited: (playerId) => {
      ArticleEvents.State.playerPlayState[playerId] = 'inited';
      return ArticleEvents.State.playerPlayState[playerId];
    },
    setPlayerIdAsNotPlaying: (playerId) => {
      ArticleEvents.State.playerPlayState[playerId] = 'not-playing';
      return ArticleEvents.State.playerPlayState[playerId];
    },
    getPlayerIdPlayingState: (playerId) => {
      return ArticleEvents.State.playerPlayState[playerId];
    },
  },
  Callbacks: {
    MakeIntersectionCallback: (videoId) => (entries) => {
      entries.forEach((entry) => {
        const isIntersecting = entry.isIntersecting;

        if (!isIntersecting) {
          ArticleEvents.Methods.PausePlayer(videoId);
        } else {
          ArticleEvents.Methods.PlayPlayer(videoId);
        }
      });
    },
  },
  Methods: {
    WatchForPlayersIntersection: (playersData, callback) => {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: [0],
      };

      playersData.forEach((playerData) => {
        const observer = new IntersectionObserver(
          callback(playerData.videoId),
          observerOptions
        );
        observer.observe(playerData.videoFrame);
      });
    },
    GetVideosData: function (players) {
      const data = players.map(function (_i, player) {
        const videoData = ArticleEvents.Methods.GetVideoIdAndFrame(player);
        return videoData;
      });
      return data.toArray();
    },
    ListenToPlayers: function () {
      let playingPlayerId = null;
      register((data = {}) => {
        if (data.eventName === 'visibilitychange' && data.id == playingPlayerId) {
          play(playingPlayerId);
        }
        const playerId = data?.customData?.videoID;
        if (!playerId) {
          return;
        }

        // eslint-disable-next-line default-case
        switch (data.eventName) {
          case 'init':
            ArticleEvents.State.setPlayerIdAsInited(playerId);
            break;
          case 'play':
            playingPlayerId = playerId;
            ArticleEvents.State.setPlayerIdAsPlaying(playerId);
            /**
             * Handle fullscreen state when a new video loads (ad or content).
             * The player may retain the fullscreen state from the previous video.
             */
            if (
              Utils.parentIsInFullscreen() &&
              !Utils.IsResponsive() &&
              !Utils.isTouchDevice()
            ) {
              toggleFullscreen(playerId, true);
            }
            break;
          case 'pause':
          case 'complete':
            ArticleEvents.State.setPlayerIdAsNotPlaying(playerId);
            break;
          case 'ended':
            ArticleEvents.State.setPlayerIdAsNotPlaying(playerId);
            $('.-fake-fullscreen').removeClass('-fake-fullscreen');
            break;
          case 'exitfullscreen':
            if (Utils.parentIsInFullscreen() && document.fullscreenElement) {
              document.exitFullscreen();
            }
            break;
        }
      });
    },
    GetVideoIdAndFrame: function (player) {
      const videoFrame = $(player).find('[data-video-id]');
      const videoId = $(videoFrame).attr('data-video-id');

      return {
        videoId,
        videoFrame: videoFrame.get(0),
      };
    },
    PlayPlayer: function (videoId) {
      const playerState = ArticleEvents.State.getPlayerIdPlayingState(videoId);
      if (playerState !== 'inited') {
        play(videoId);
      }
    },
    PausePlayer: function (videoId) {
      const playerState = ArticleEvents.State.getPlayerIdPlayingState(videoId);
      if (playerState === 'playing') {
        pause(videoId);
      }
    },
  },
};

export default ArticleEvents;
window.ArticleEvents = ArticleEvents;